import { identity, memoizeWith, toString } from 'ramda'

const memoize = memoizeWith(toString, identity)

export default memoize
